import { render } from "./InteractiveMenu.vue?vue&type=template&id=4888422e&scoped=true&ts=true"
import script from "./InteractiveMenu.vue?vue&type=script&lang=ts"
export * from "./InteractiveMenu.vue?vue&type=script&lang=ts"

import "./InteractiveMenu.vue?vue&type=style&index=0&id=4888422e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4888422e"]])

export default __exports__